import React from "react";

const PhotovoltaiquesImages_en = () => {
  return (
    <section className="white-bg ">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title text-left">
              <h2 className="title-effect ">Our Projects</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 text-center">
          {/** 
          <div className="isotope-filters">
              <button data-filter="*" className="active">
                All
              </button>
              <button data-filter=".almes">Projet photovoltaïque ALMES</button>
              <button data-filter=".EPPM-SITE-MEKNASSI">
                EPPM SITE MEKNASSI{" "}
              </button>
              <button data-filter=".SITE-COFICAB-MJEZ-BEB">
                SITE COFICAB MJEZ BEB{" "}
              </button>
              <button data-filter=".ETELSOL-KOUTINE-MEDENINE">
                ETELSOL SITE KOUTINE MEDENINE{" "}
              </button>
              <button data-filter=".ELECTRO-RAPIDE-SKHIRA">
                ELECTRO RAPIDE SKHIRA{" "}
              </button>
            </div>
          */}
            
            <div className="isotope columns-3 popup-gallery">
              <div className="grid-item ELECTRO-RAPIDE-SKHIRA">
                <div className="portfolio-item">
                  <img
                  style={{height:"247px"}}
                    src="/assets/images/photovoltaïques/electrorapid.png"
                    alt
                  />
                  {/**
                   <div className="portfolio-overlay">
                    <h4 className="text-white">
                      {" "}
                      <a href="portfolio-single-01.html">
                        {" "}
                        ELECTRO RAPIDE SKHIRA{" "}
                      </a>{" "}
                    </h4>
                    <span className="text-white">
                      {" "}
                      <a href="#">1000-0.4-31.5-YNYN0-AL-PC01/26-CO*2</a>{" "}
                    </span>
                  </div>
                   */}
                 
                  <a
                    className="popup portfolio-img"
                    href="/assets/images/photovoltaïques/electrorapid.png"
                  >
                    <i className="fa fa-arrows-alt" />
                  </a>
                </div>
              </div>
             
              <div className="grid-item almes ">
                <div className="portfolio-item">
                  <img
                   style={{height:"247px"}}
                    src="/assets/images/photovoltaïques/novagreenvolt_sacem.png"
                    alt
                  />
                  {/**
                   <div className="portfolio-overlay">
                    <h4 className="text-white">
                      {" "}
                      <a href="portfolio-single-01.html"> SNA </a>{" "}
                    </h4>
                    <span className="text-white">
                      {" "}
                      <a href="#">3150-30-0.8-YNYN0-AL-PC28/25 *2</a>{" "}
                    </span>
                  </div>
                   */}
                 
                  <a
                    className="popup portfolio-img"
                    href="/assets/images/photovoltaïques/novagreenvolt_sacem.png"
                  >
                    <i className="fa fa-arrows-alt" />
                  </a>
                </div>
              </div>
              <div className="grid-item almes ">
                <div className="portfolio-item">
                  <img
                   style={{height:"247px"}}
                    src="/assets/images/photovoltaïques/novagreenvolt_sacem1.png"
                    alt
                  />
                  {/**
                  <div className="portfolio-overlay">
                    <h4 className="text-white">
                      {" "}
                      <a href="portfolio-single-01.html"> SNA </a>{" "}
                    </h4>
                    <span className="text-white">
                      {" "}
                      <a href="#">3150-30-0.8-YNYN0-AL-PC28/25 *2</a>{" "}
                    </span>
                  </div>
                   */}
                  
                  <a
                    className="popup portfolio-img"
                    href="/assets/images/photovoltaïques/novagreenvolt_sacem1.png"
                  >
                    <i className="fa fa-arrows-alt" />
                  </a>
                </div>
              </div>
             
             
         
          
             

        
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhotovoltaiquesImages_en;
